import router from "./index";

router.beforeEach((to, from, next) => {
  // if(to.matched.some(res => res.meta.isLogin))
  // {
  //     if(sessionStorage["un"])
  //     {
  //         next();
  //     }
  //     else
  //     {
  //         next({
  //             path: "/user/login",
  //             query:{
  //                 redirect: to.fullPath
  //             }
  //         });
  //     }
  // }
  // else
  // {
  next();
  // }
});

export default router;
